import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export const honoreesModalSlidersMap = new Map();

export function honoreesModalSlider() {
  let honorees_modal_sliders = document.querySelectorAll(".common_modal_slider");

  honorees_modal_sliders.forEach(el => {
    const id = el.closest('.common_modal')?.id;
    if (!id) return;

    const swiperInstance = new Swiper(el, {
      loop: true,
      speed: 400,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      a11y: {
        containerMessage:'プロフィールのスライド表示エリアです',
        prevSlideMessage: '前のスライドへ',
        nextSlideMessage: '次のスライドへ',
      },
    });

    honoreesModalSlidersMap.set(id, swiperInstance);
  });
}
